module.exports = __webpack_public_path__ + "static/media/certificate.c2110196.svg";